<template>
  <div class="league-tier-tabs">
    <button
      v-for="tier in tiers"
      :key="tier.value"
      :class="['tier-tab', { active: value === tier.value }]"
      @click="$emit('input', tier.value)"
    >
      <img :src="tier.icon" :alt="tier.label" class="tier-icon" />
      <span class="tier-label">{{ tier.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LeagueTierTabs',
  props: {
    value: {
      type: String,
      default: 'gold'
    },
    primaryColor: {
      type: String,
      default: '#0066FF'
    },
    tierAccentColor: {
      type: String,
      default: '#FFD700'
    }
  },
  data() {
    return {
      tiers: [
        {
          value: 'platinum',
          label: 'Platinum',
          icon: require('@/apps/broker/designs/leagues/platinum-icon.png')
        },
        {
          value: 'gold',
          label: 'Gold',
          icon: require('@/apps/broker/designs/leagues/gold-icon.png')
        },
        {
          value: 'silver',
          label: 'Silver',
          icon: require('@/apps/broker/designs/leagues/silver-icon.png')
        },
        {
          value: 'bronze',
          label: 'Bronze',
          icon: require('@/apps/broker/designs/leagues/bronze-icon.png')
        }
      ]
    };
  },
  computed: {
    activeTextColor() {
      const color = this.primaryColor.replace('#', '');
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return yiq >= 128 ? '#000000' : '#FFFFFF';
    }
  }
};
</script>

<style lang="scss" scoped>
.league-tier-tabs {
  display: inline-flex;
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 0;
  gap: 0;
  align-items: stretch;
  height: 40px;
  position: relative;
  transition: box-shadow 0.3s ease;
  box-shadow: 0 0 0 3px transparent, 0 0 20px 0 v-bind(tierAccentColor + '15');

  &::before {
    content: '';
    position: absolute;
    inset: -4px;
    border-radius: 10px;
    background: radial-gradient(ellipse at center, v-bind(tierAccentColor + '20') 0%, transparent 70%);
    z-index: -1;
    opacity: 0.6;
  }
}

.tier-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  color: #3B3B3B;
  font-family: 'Avenir', sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover:not(.active) {
    color: #1A1A1A;
  }

  &.active {
    background-color: v-bind(primaryColor);
    color: v-bind(activeTextColor);
  }

  .tier-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .tier-label {
    white-space: nowrap;
    font-weight: bold;
  }
}

.theme--dark .league-tier-tabs {
  background-color: #2A2A2A;
}

.theme--dark .tier-tab {
  color: #FFFFFF;

  &:hover:not(.active) {
    color: #FFFFFF;
  }

  &.active {
    background-color: v-bind(primaryColor);
    color: v-bind(activeTextColor);
  }
}
</style>
